import { useState } from 'react'
import { repository } from '../../data'
import type { View } from './derive'
import { Avatar, useWrite } from './parts'

const JOB: Readonly<Record<string, string>> = { admin: 'Admin', engineer: 'Engineer', technician: 'Technician', intake: 'Intake' }

/**
 * Kronos accounts not listed here: by default the intake desk and technicians
 * who only build, plus anyone an admin chose to leave out. One press lists them.
 */
export function HiddenPeople({ view }: { view: View }): JSX.Element | null {
  const [open, setOpen] = useState(false)
  const show = useWrite((userId: string) => repository.setVisibility(userId, 'shown'), (userId) => `${view.person(userId)?.name} is listed in Connectivity`)
  if (view.hidden.length === 0) return null
  return (
    <section className="cx-panel cx-panel--padded" aria-label="Not listed in Connectivity">
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <span className="stack" style={{ gap: 2 }}>
          <h2 className="cx-panel__title">Not listed · {view.hidden.length}</h2>
          <span className="muted cx-small">Kronos accounts that do not need SSH — by default the intake desk and technicians who only build.</span>
        </span>
        <button onClick={() => setOpen((o) => !o)} aria-expanded={open}>{open ? 'Close' : 'Show them'}</button>
      </div>
      {open ? (
        <ul className="cx-list">
          {view.hidden.map((p) => (
            <li key={p.id} className="cx-list__row cx-found__row">
              <span className="row" style={{ gap: 10, minWidth: 0 }}>
                <Avatar initials={p.initials} online={p.online} />
                <span className="stack" style={{ gap: 0, minWidth: 0 }}>
                  <span className="cx-strong">{p.name}</span>
                  <span className="muted cx-small">
                    {p.roles.map((r) => JOB[r] ?? r).join(', ')} · {p.visibility === 'hidden' ? 'left out by an admin' : 'not listed by default'}
                  </span>
                </span>
              </span>
              <button disabled={show.pending} onClick={() => show.run(p.id)}>List</button>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  )
}
